import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
// import formatData from "../utils/formatData";
const bqGetReportChallengeDataByGroup = async function (compettionId, groupId, startDate, endDate) {
    const app = firebase.app();
    const functions = getFunctions(app, 'asia-east2');
    const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');
    let additionalQuery = `
            member.groupId = '${groupId}'
        `;
    if (groupId == 'user' || groupId == undefined) {
        additionalQuery = `
            1=1
        `;
    }
    const result = await Promise.all([
        queryThaisookViewBigQuery({
            info: 'get group membr report',
            query: `
                CREATE TEMP FUNCTION totalHealthpoint(food numeric,water numeric, sleep numeric, other numeric, workout numeric, step numeric,date_str string)
                RETURNS numeric
                LANGUAGE js
                AS r"""
                  var date = new Date(date_str);
                  var sum =0;
                  var totalWorkout = workout + step;
                  if(totalWorkout > 5 ) totalWorkout = 5;
                  if(food > 5) food = 5;
                  if(sleep > 2) sleep = 2;
                  if(water > 0) other = 1;
                  if(other > 1) other = 1;
                  if(date <= new Date('2025-07-23')) {
                    sum = totalWorkout + food + sleep + other;
                  } else {
                    other = other + sleep + water;
                    if(other > 1) other = 1;
                    sum = totalWorkout + food + other;
                  }
                  
                  if (sum > 10) sum = 10;
                  return sum;
                """;
                with member as (
                    SELECT 
                        U.uid,
                        U.employeeId,
                        CU.groupId,
                        concat(U.firstname, ' ', U.lastname) name,
                        U.pictureUrl 
                    FROM 
                        thaisook_view.competition C
                        join thaisook_view.competition_users CU
                            on C.competitionId = CU.competitionId
                        join thaisook_view.users U
                            on U.uid = CU.uid
                    WHERE
                        C.competitionId = '${compettionId}'
                ),
                pointDataFromHealthpoint as (
                    SELECT 
                        HP.date,
                        HP.uid,
                        totalHealthpoint(HP.foodScore, HP.waterScore, HP.sleepScore, HP.otherScore, HP.workoutScore, HP.stepScore, cast(HP.date as string)) as healthPoint
                    FROM 
                        thaisook_view.competition C
                        join thaisook_view.competition_users CU
                            on C.competitionId = CU.competitionId
                        join activity_view.healthpoint HP
                            on HP.uid = CU.uid 
                            and date(HP.date) >= date(C.startDate)
                            and date(HP.date) >= date(CU.startWeightDate) 
                            and date(HP.date) <= date(C.endDate)
                            and date(HP.date) between date('${startDate}') and date('${endDate}')
                    WHERE
                        C.competitionId = '${compettionId}'
                ),
                pointData as (
                    select uid, sum(healthPoint) totalHealthpoint from pointDataFromHealthpoint group by uid
                ),
                weightDataFromHealthdata as (
                    SELECT 
                        HD.uid,
                        HD.date,
                        HD.weight,
                        FIRST_VALUE(HD.weight) OVER(PARTITION BY HD.uid ORDER BY date) AS start_weight,
                        LAST_VALUE(HD.weight) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_weight,
                        FIRST_VALUE(HD.bmi) OVER(PARTITION BY HD.uid ORDER BY date) AS start_bmi,
                        LAST_VALUE(HD.bmi) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_bmi,
                        ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY date DESC) AS last_record
                    FROM 
                        thaisook_view.healthdata HD
                        join thaisook_view.competition_users CU
                            on CU.uid = HD.uid 
                        join thaisook_view.competition C 
                            on C.competitionId = CU.competitionId
                    where 
                        HD.weight is not null
                        and CU.competitionId = '${compettionId}'
                        and date(HD.date) >= date(C.startDate)
                        and date(HD.date) >= date(CU.startWeightDate)
                        and date(HD.date) <= date(C.endDate)
                        and date(HD.date) between date('${startDate}') and date('${endDate}')
                ),
                weightData as (
                    select 
                        uid,
                        sum(end_weight - start_weight) as totalWeightLoss,
                        ROUND(sum((end_weight - start_weight) / start_weight) * 100, 2) as totalWeightLossPercentage,
                        sum(end_bmi - start_bmi) as bmiChange
                    from 
                        weightDataFromHealthdata 
                    where 
                        last_record = 1 
                    group by uid
                ),
                distanceData as (
                    SELECT 
                        CA.uid,
                        sum(CA.totalWorkout) as totalWorkout,
                        sum(case when CA.activityType = 'run' then CA.distance else 0 end) as totalDistance,
                        sum(CA.serving) as totalServing
                    FROM 
                        thaisook_view.competition C
                        join thaisook_view.competition_users CU
                            on C.competitionId = CU.competitionId
                        join activity_view.competition_activities CA 
                            on C.competitionId = CA.competitionId
                            and CA.uid = CU.uid
                            and date(CA.date) >= date(C.startDate)
                            and date(CA.date) >= date(CU.startWeightDate)
                            and date(CA.date) <= date(C.endDate)
                            and date(CA.date) between date('${startDate}') and date('${endDate}')
                        WHERE
                            C.competitionId = '${compettionId}'
                            and CA.reportFlag = false
                    group by CA.uid
                ),   
                workoutNumberData as(
                    SELECT 
                        CA.uid,
                        count(1) as totalWorkoutNumber
                    FROM 
                        thaisook_view.competition C
                        join thaisook_view.competition_users CU
                            on C.competitionId = CU.competitionId
                        join activity_view.competition_activities CA 
                            on C.competitionId = CA.competitionId
                            and CU.uid = CA.uid
                            and date(CA.date) >= date(C.startDate)
                            and date(CA.date) >= date(CU.startWeightDate)
                            and date(CA.date) <= date(C.endDate)
                            and date(CA.date) between date('${startDate}') and date('${endDate}')
                    WHERE
                        C.competitionId = '${compettionId}'
                        and CA.reportFlag = false
                        and CA.totalWorkout > 0
                    group by CA.uid
                ),  
                stepData as (
                    SELECT 
                        CU.uid,
                        sum(case when WO.steps > C.maxStepsPerDay THEN C.maxStepsPerDay ELSE WO.steps END) as totalSteps
                    FROM 
                        thaisook_view.competition C
                            join thaisook_view.competition_users CU
                                on C.competitionId = CU.competitionId
                            join activity_view.workout WO
                                on WO.uid = CU.uid 
                                and date(WO.date) >= date(C.startDate)
                                and date(WO.date) >= date(CU.startWeightDate)
                                and date(WO.date) <= date(C.endDate)
                                and date(WO.date) between date('${startDate}') and date('${endDate}')
                    WHERE
                        C.competitionId = '${compettionId}'
                    group by CU.uid
                )
                select 
                    member.uid,
                    member.name,
                    member.employeeId,
                    member.pictureUrl,
                    PD.totalHealthpoint healthpoints_total,
                    WD.totalWeightLoss weight_loss,
                    WD.totalWeightLossPercentage weight_loss_percent,
                    WD.bmiChange bmi_changes,
                    DD.totalServing servings,
                    WN.totalWorkoutNumber workout_number,
                    DD.totalWorkout workout_minutes,
                    DD.totalDistance distance,
                    SD.totalSteps steps
                from 
                    member
                        left join pointData PD on PD.uid = member.uid
                        left join weightData WD on WD.uid = member.uid
                        left join distanceData DD on DD.uid = member.uid
                        left join workoutNumberData WN on WN.uid = member.uid
                        left join stepData as SD on SD.uid = member.uid
                where 
                    ${additionalQuery}

            `
        })
    ]);

    const groupMemberObj = JSON.parse(result[0].data);
    return groupMemberObj;
};
export default bqGetReportChallengeDataByGroup;
